module.exports = __webpack_public_path__ + "media/images/quizGray-d5cf3893506d59db9370ea1423abdb27.svg";